import { getApolloClient } from '@faustwp/core';
import { SEO } from '../../components';
import {
  Header,
  Footer,
  HeroSection,
  FinalCTASection,
} from '../../components/sections';
import {
  ContactPeopleSection,
  ContactCompanySection,
  ContactOfficesSection,
  CONTACT_PEOPLE,
} from '../../components/sections/contact';
import { getCanonicalUrl, buildHreflangTags } from '../../lib/siteUrl';
import { fetchPageSettings } from '../../lib/queries/pageSettings';

const FALLBACK_FI = {
  metaTitle: 'Yhteys | Identio',
  metaDescription:
    'Harkitsetko yhteistyötä vai haluatko vain keskustella? Ota yhteyttä tiimiimme—autamme mielellämme projektisi kanssa tai vastaamme kysymyksiin.',
  heroTitle: 'Harkitsetko yhteistyötä vai haluatko vain keskustella?',
  heroDescription:
    'Ota yhteyttä tiimiimme—autamme mielellämme projektisi kanssa tai vastaamme kysymyksiin.',
  ctaTitle: 'Ota yhteyttä',
  ctaSubtitle: 'Lähetä viesti ja kerro ajatuksesi. Palaamme asiaan mahdollisimman pian.',
  ctaButtonText: 'Ota yhteyttä tiimiin',
};

export default function YhteysPage({ yhteysSettings = null }) {
  const s = yhteysSettings ?? {};
  const title = s.seoTitle ?? s.metaTitle ?? s.meta_title ?? FALLBACK_FI.metaTitle;
  const description = s.seoDescription ?? s.metaDescription ?? s.meta_description ?? FALLBACK_FI.metaDescription;
  const heroTitle = s.heroTitle ?? s.hero_title ?? FALLBACK_FI.heroTitle;
  const heroDescription = s.heroDescription ?? s.hero_description ?? FALLBACK_FI.heroDescription;
  const ctaTitle = s.ctaTitle ?? s.cta_title ?? FALLBACK_FI.ctaTitle;
  const ctaSubtitle = s.ctaSubtitle ?? s.cta_subtitle ?? FALLBACK_FI.ctaSubtitle;
  const ctaButtonText = s.ctaButtonText ?? s.cta_button_text ?? FALLBACK_FI.ctaButtonText;

  return (
    <>
      <SEO title={title} description={description} url={getCanonicalUrl('/yhteys')} alternates={buildHreflangTags('/yhteys', '/contact')} />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection variant="contact" title={heroTitle} description={heroDescription} />
        <ContactPeopleSection />
        <FinalCTASection
          variant="withForm"
          title={ctaTitle}
          subtitle={ctaSubtitle}
          contacts={CONTACT_PEOPLE}
          contactButtonText={ctaButtonText}
          showContactSidebar={false}
        />
        <ContactCompanySection />
        <ContactOfficesSection />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  let yhteysSettings = null;
  try {
    const client = getApolloClient();
    yhteysSettings = await fetchPageSettings(client, 'yhteys');
    if (process.env.NODE_ENV !== 'production') {
      console.log('YHTEYS_DEBUG getStaticProps:', yhteysSettings ? 'OK' : 'NULL', yhteysSettings ? Object.keys(yhteysSettings).join(',') : '');
    }
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('YHTEYS_DEBUG ERROR:', e?.message ?? e);
    }
  }
  return {
    props: { yhteysSettings },
    revalidate: 300,
  };
}
